import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import moment from 'moment'
import config from '../../config'
import format from '../../helpers/format'
import {
  Link,
  LinkIcon
} from '../../components'

import Styles from './TargetDateSeriesNameHeader.css'


@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeriesNameHeader extends Component {
  static propTypes = {
    // the target date series object
    targetDateSeries: PropTypes.object.isRequired,
  }
  constructor(props) {
    super(props)
  }

  render() {
    const { targetDateSeries } = this.props

    const fileName = format.imgPath(targetDateSeries.fund_family_name)
    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/fam/'+fileName+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }

    // const famUrl = config.routes.families+'?q='+encodeURIComponent(targetDateSeries.fund_family_name)

    //
    return (
      <div>
        <div styleName='name-flex'>
          <div>
            <h1 styleName='name'>
              { targetDateSeries.strategy_name }
              {
                targetDateSeries.sustainable_investment ?
                  (
                    <span styleName='leaf'>
                      <LinkIcon faclass='fa-leaf' />
                    </span>
                  ) :
                  null
              }
            </h1>
          </div>
          <div>
            { /*
            <div styleName='name-label-logo'>
              {
                hasLogo ?
                  (
                    <img
                      styleName='name-logo'
                      src={companyLogo}
                      alt={targetDateSeries.fund_family_name}
                    />
                  ) :
                  (
                    <span>{targetDateSeries.fund_family_name}</span>
                  )
              }
            </div>
            */ }
            <div styleName='name-label'>
              <Link
                to={config.routes.targetDateFunds}
                title={'Target date funds'}
                xstrong
              >
                Target date fund series
              </Link>
            </div>
            <div styleName='name-label'>
              Rated as <b>{targetDateSeries.fund_legal_name}</b>
            </div>
            <div styleName='name-label'>
              Portfolio date <b>{
                moment(targetDateSeries.portfolio_date).format('MMM YYYY')
              }</b>
            </div>
          </div>
        </div>
      </div>
    )
  }
}